import { dayjs } from '../../../dayjs.ts'

// Bucket IDs shown/filtered in the service map "last read" filter. Split out from ServiceMapFilters.tsx
// so the store (states.ts) can sanitize persisted values on rehydrate without a circular import.
export const LAST_READ_BUCKETS = ['H_1_11', 'H_12_23', 'H_24_35', 'H_36_47', 'H_48_168', 'OVER_1_WEEK', 'OVER_3_MONTHS'] as const
export type LastReadBucket = (typeof LAST_READ_BUCKETS)[number]

const VALID_LAST_READ_BUCKETS = new Set<string>(LAST_READ_BUCKETS)

export const isValidLastReadBucket = (value: string): value is LastReadBucket => VALID_LAST_READ_BUCKETS.has(value)

// dayjs's relativeTime plugin rounds anything past ~22 hours up to "1 D", which hides the individual
// hour count right where the H_12_23/H_24_35/H_36_47 buckets above still care about it. Below the same
// 48h mark used by those buckets, format the hour count ourselves; past it, defer to dayjs's own (more
// relaxed) rounding rather than maintaining a second set of day/week/month thresholds here.
export const formatLastRead = (lastRead: string): string => {
	const read = dayjs(lastRead)
	const diffHours = dayjs().diff(read, 'hour')
	if (diffHours < 1 || diffHours > 48) return read.fromNow(true)

	const relativeTime = dayjs.Ls[dayjs.locale()]?.relativeTime
	const template = diffHours === 1 ? relativeTime?.h : relativeTime?.hh
	return template ? template.replace('%d', String(diffHours)) : read.fromNow(true)
}
